<div class="mechanic-inspection-form">
    <!-- Header Fields -->
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="mechWorkOrder">Work Order #</label>
                <input type="text" class="form-control" [(ngModel)]="inspection().workOrderNumber" name="mechWorkOrder" id="mechWorkOrder" />
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="mechEquipmentId">Equipment ID</label>
                <wj-combo-box
                    [(ngModel)]="inspection().equipmentId"
                    name="mechEquipmentId"
                    id="mechEquipmentId"
                    [itemsSource]="equipmentOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="mechDateTime">Date</label>
                <wj-input-date-time
                    [(ngModel)]="inspection().dateTime"
                    name="mechDateTime"
                    id="mechDateTime"
                    [isRequired]="false"
                ></wj-input-date-time>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="mechMechanic">Mechanic</label>
                <wj-combo-box
                    [(ngModel)]="inspection().mechanic"
                    name="mechMechanic"
                    id="mechMechanic"
                    [itemsSource]="employeeOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="mechHours">Hours</label>
                <input type="text" class="form-control" [(ngModel)]="inspection().hours" name="mechHours" id="mechHours" />
            </div>
        </div>
    </div>

    <!-- Verify Complaint -->
    <div class="checklist-section">
        <h6 class="checklist-heading">Verify Complaint</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="verifyComplaint">Result</label>
                    <wj-combo-box
                        [(ngModel)]="inspection().verifyComplaint"
                        name="verifyComplaint"
                        id="verifyComplaint"
                        [itemsSource]="verifyComplaintOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="verifyComplaintNotes">Notes</label>
                    <input type="text" class="form-control" [(ngModel)]="inspection().verifyComplaintNotes" name="verifyComplaintNotes" id="verifyComplaintNotes" />
                </div>
            </div>
        </div>
    </div>

    <!-- Visual Inspection -->
    <div class="checklist-section">
        <h6 class="checklist-heading">Visual Inspection</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label>Findings</label>
                    <wj-multi-select
                        name="visualInspection"
                        [itemsSource]="visualInspectionOptions"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [placeholder]="'Select findings...'"
                        [showSelectAllCheckbox]="false"
                        [showFilterInput]="true"
                        [headerFormatter]="multiSelectHeaderFormatter"
                        (checkedItemsChanged)="onVisualInspectionChanged()"
                    ></wj-multi-select>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="visualNotes">Notes</label>
                    <input type="text" class="form-control" [(ngModel)]="inspection().visualInspectionNotes" name="visualNotes" id="visualNotes" />
                </div>
            </div>
        </div>
    </div>

    <!-- Fluids & Filters -->
    <div class="checklist-section">
        <h6 class="checklist-heading">Fluids &amp; Filters</h6>
        <div class="row">
            @for (item of inspection().fluidsFilters; track item.label; let i = $index) {
                <div class="col-sm-6 col-12">
                    <div class="checklist-row">
                        <span class="checklist-label">{{ item.label }}</span>
                        <wj-combo-box
                            [(ngModel)]="item.status"
                            [name]="'fluid_' + i"
                            [itemsSource]="getFluidStatusOptions(item)"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            }
        </div>
    </div>

    <!-- Engine Check -->
    <div class="checklist-section">
        <h6 class="checklist-heading">Engine Check</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label>Symptoms</label>
                    <wj-multi-select
                        name="engineSymptoms"
                        [itemsSource]="engineSymptomOptions"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [placeholder]="'Select symptoms...'"
                        [showSelectAllCheckbox]="false"
                        [showFilterInput]="false"
                        [headerFormatter]="multiSelectHeaderFormatter"
                        (checkedItemsChanged)="onEngineSymptomsChanged()"
                    ></wj-multi-select>
                </div>
            </div>
            @if (inspection().engineSymptoms.includes('Excess smoke')) {
                <div class="col-sm-6 col-12">
                    <div class="form-group">
                        <label for="smokeColor">Smoke Color</label>
                        <wj-combo-box
                            [(ngModel)]="inspection().excessSmokeColor"
                            name="smokeColor"
                            id="smokeColor"
                            [itemsSource]="smokeColorOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            }
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label>Basic Checks</label>
                    <wj-multi-select
                        name="engineBasicChecks"
                        [itemsSource]="engineBasicCheckOptions"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [placeholder]="'Select checks...'"
                        [showSelectAllCheckbox]="false"
                        [showFilterInput]="false"
                        [headerFormatter]="multiSelectHeaderFormatter"
                        (checkedItemsChanged)="onEngineBasicChecksChanged()"
                    ></wj-multi-select>
                </div>
            </div>
        </div>
    </div>

    <!-- Hydraulic System -->
    <div class="checklist-section">
        <h6 class="checklist-heading">Hydraulic System</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label>Symptoms</label>
                    <wj-multi-select
                        name="hydraulicSymptoms"
                        [itemsSource]="hydraulicSymptomOptions"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [placeholder]="'Select symptoms...'"
                        [showSelectAllCheckbox]="false"
                        [showFilterInput]="false"
                        [headerFormatter]="multiSelectHeaderFormatter"
                        (checkedItemsChanged)="onHydraulicSymptomsChanged()"
                    ></wj-multi-select>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label>Checks</label>
                    <wj-multi-select
                        name="hydraulicChecks"
                        [itemsSource]="hydraulicCheckOptions"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [placeholder]="'Select checks...'"
                        [showSelectAllCheckbox]="false"
                        [showFilterInput]="false"
                        [headerFormatter]="multiSelectHeaderFormatter"
                        (checkedItemsChanged)="onHydraulicChecksChanged()"
                    ></wj-multi-select>
                </div>
            </div>
        </div>
    </div>

    <!-- Electrical System -->
    <div class="checklist-section">
        <h6 class="checklist-heading">Electrical System</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label>Checks</label>
                    <wj-multi-select
                        name="electricalChecks"
                        [itemsSource]="electricalCheckOptions"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [placeholder]="'Select checks...'"
                        [showSelectAllCheckbox]="false"
                        [showFilterInput]="false"
                        [headerFormatter]="multiSelectHeaderFormatter"
                        (checkedItemsChanged)="onElectricalChecksChanged()"
                    ></wj-multi-select>
                </div>
            </div>
            @if (inspection().electricalChecks.includes('Fault codes checked')) {
                <div class="col-sm-6 col-12">
                    <div class="form-group">
                        <label for="faultCodes">Fault Codes</label>
                        <input type="text" class="form-control" [(ngModel)]="inspection().faultCodes" name="faultCodes" id="faultCodes" placeholder="Enter codes..." />
                    </div>
                </div>
            }
        </div>
    </div>

    <!-- Drivetrain / Travel -->
    <div class="checklist-section">
        <h6 class="checklist-heading">Drivetrain / Travel</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label>Findings</label>
                    <wj-multi-select
                        name="drivetrainSymptoms"
                        [itemsSource]="drivetrainOptions"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [placeholder]="'Select findings...'"
                        [showSelectAllCheckbox]="false"
                        [showFilterInput]="false"
                        [headerFormatter]="multiSelectHeaderFormatter"
                        (checkedItemsChanged)="onDrivetrainChanged()"
                    ></wj-multi-select>
                </div>
            </div>
        </div>
    </div>

    <!-- Brakes -->
    <div class="checklist-section">
        <h6 class="checklist-heading">Brakes</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label>Findings</label>
                    <wj-multi-select
                        name="brakeFindings"
                        [itemsSource]="brakeOptions"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [placeholder]="'Select findings...'"
                        [showSelectAllCheckbox]="false"
                        [showFilterInput]="false"
                        [headerFormatter]="multiSelectHeaderFormatter"
                        (checkedItemsChanged)="onBrakeChanged()"
                    ></wj-multi-select>
                </div>
            </div>
        </div>
    </div>

    <!-- Cooling System -->
    <div class="checklist-section">
        <h6 class="checklist-heading">Cooling System</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label>Findings</label>
                    <wj-multi-select
                        name="coolingFindings"
                        [itemsSource]="coolingOptions"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [placeholder]="'Select findings...'"
                        [showSelectAllCheckbox]="false"
                        [showFilterInput]="false"
                        [headerFormatter]="multiSelectHeaderFormatter"
                        (checkedItemsChanged)="onCoolingChanged()"
                    ></wj-multi-select>
                </div>
            </div>
        </div>
    </div>

    <!-- Attachment -->
    <div class="checklist-section">
        <h6 class="checklist-heading">Attachment</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label>Findings</label>
                    <wj-multi-select
                        name="attachmentFindings"
                        [itemsSource]="attachmentOptions"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [placeholder]="'Select findings...'"
                        [showSelectAllCheckbox]="false"
                        [showFilterInput]="false"
                        [headerFormatter]="multiSelectHeaderFormatter"
                        (checkedItemsChanged)="onAttachmentChanged()"
                    ></wj-multi-select>
                </div>
            </div>
        </div>
    </div>

    <!-- Cause -->
    <div class="checklist-section">
        <h6 class="checklist-heading">Cause</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="causeIdentified">Identified?</label>
                    <wj-combo-box
                        [(ngModel)]="inspection().causeIdentified"
                        name="causeIdentified"
                        id="causeIdentified"
                        [itemsSource]="causeOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="causeDescription">Description</label>
                    <input type="text" class="form-control" [(ngModel)]="inspection().causeDescription" name="causeDescription" id="causeDescription" placeholder="Describe cause..." />
                </div>
            </div>
        </div>
    </div>

    <!-- Status -->
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="mechStatus">Status</label>
                <wj-combo-box
                    [(ngModel)]="inspection().status"
                    name="mechStatus"
                    id="mechStatus"
                    [itemsSource]="statusOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>

    <!-- Mechanic Notes -->
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label for="mechanicNotes">Mechanic Notes</label>
                <textarea
                    rows="4"
                    class="form-control"
                    [(ngModel)]="inspection().mechanicNotes"
                    name="mechanicNotes"
                    id="mechanicNotes"
                    placeholder="Enter mechanic notes..."
                ></textarea>
            </div>
        </div>
    </div>
</div>
